module.exports = __webpack_public_path__ + "static/media/closed-chat-modal.615338b9.svg";